import { Component} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DbService } from '../../db.service';
import { SessionService } from '../../session.service';
import { RecSenha, ViewRetornoRecSenha } from './login.class'

@Component({
    selector: 'app-recuperar-senha',
    templateUrl: './app-recuperar-senha.component.html',
    styleUrls: ['./app-recuperar-senha.component.css']
})

export class AppRecuperarSenhaComponent {

    formRecSenha: FormGroup;
    senhaDiferente: boolean = false;
    resetValido: boolean = false;
    senhaMenor: boolean = false;

    constructor(
        private dbService: DbService,
        private router: Router,
        private route: ActivatedRoute,
        private sessionService: SessionService,

    ) {
        this.formRecSenha = new FormGroup({
            numSenha: new FormControl('', Validators.required),
            confSenha: new FormControl('', Validators.required)
        });
    }

    fnEntrar() {

        this.senhaDiferente = false;
        this.resetValido = false;
        this.senhaMenor = false;

        // Valida formulário
        if (!this.formRecSenha.valid) {
            // Exibe erros
            for (let ctrl in this.formRecSenha.controls) { this.formRecSenha.controls[ctrl].markAsTouched(); }
        }
        else {

            let recSenha = new RecSenha();

            recSenha.numSenha = this.formRecSenha.controls['numSenha'].value;
            recSenha.confSenha = this.formRecSenha.controls['confSenha'].value;
            recSenha.codSenha = this.route.snapshot.params['id'];

            if (recSenha.numSenha.length < 8 || recSenha.confSenha.length < 8) {

                this.senhaMenor = true;

            }
            else if (recSenha.numSenha !== recSenha.confSenha) {

                this.senhaDiferente = true;
            }
            else {

                this.dbService.post('Login/ResetSenha', recSenha).subscribe((result: ViewRetornoRecSenha) => {
                    if (result.validaSenha === true) {

                        this.resetValido = true;


                    } else {

                    }
                });
            }
        }
    }
}
